import { http } from '@/utils'

export const flowPreviewApi = (data: any): any => http.post(`/workflow/preview`, data)

export const flowInstNodeApi = (data: any): any =>
  http.get(`/workflow/inst_hotchpotch/${data}?type=1`, {})
